/**
 * useReport — TanStack Query hook for the two report tabs (CR-0015 / Δ-14).
 *
 * CR-0024 (Δ-22, 2026-06-01): reverted the `type` query-key segment
 * added by CR-0021's optional toggle clause. Backend defaults to
 * `"waiting"`; UI no longer reaches `type != "waiting"`.
 */
import { useQuery } from "@tanstack/react-query";
import { fetchCurrentDate, fetchDayWise } from "@/api/reports";

export function useReport(tab, from, to) {
  return useQuery({
    queryKey: ["report", tab, from, to],
    queryFn: () =>
      tab === "daywise" ? fetchDayWise(from, to) : fetchCurrentDate(from, to),
    enabled: !!from && !!to,
    staleTime: 30_000,
  });
}
